var map = {
	"./branded-asset.png": 4236,
	"./branded-asset@2x.png": 3188,
	"./branded-asset@3x.png": 7377,
	"./digital-toolkits.png": 7993,
	"./digital-toolkits@2x.png": 9804,
	"./digital-toolkits@3x.png": 6253,
	"./document-repository.png": 1003,
	"./document-repository@2x.png": 525,
	"./document-repository@3x.png": 1618,
	"./dulux-academy.png": 5217,
	"./dulux-academy@2x.png": 9175,
	"./dulux-academy@3x.png": 7001,
	"./focus-of-the-month.png": 7873,
	"./focus-of-the-month@2x.png": 4821,
	"./focus-of-the-month@3x.png": 2216,
	"./help-videos.png": 5811,
	"./help-videos@2x.png": 419,
	"./help-videos@3x.png": 632,
	"./industry-events.png": 7085,
	"./industry-events@2x.png": 1820,
	"./industry-events@3x.png": 8157,
	"./industry-insights.png": 5415,
	"./industry-insights@2x.png": 1521,
	"./industry-insights@3x.png": 4805,
	"./knowledge-base.png": 7059,
	"./knowledge-base@2x.png": 1280,
	"./knowledge-base@3x.png": 6267,
	"./new-product-development.png": 4305,
	"./new-product-development@2x.png": 1562,
	"./new-product-development@3x.png": 9764,
	"./newsletter-repository.png": 3190,
	"./newsletter-repository@2x.png": 3281,
	"./newsletter-repository@3x.png": 7976,
	"./rebate-scheme.png": 5286,
	"./rebate-scheme@2x.png": 6726,
	"./rebate-scheme@3x.png": 1776,
	"./think-forward/npd.png": 6767,
	"./think-forward/npd@2x.png": 2226,
	"./think-forward/npd@3x.png": 122,
	"./video-training.png": 9714,
	"./video-training@2x.png": 8849,
	"./video-training@3x.png": 5370,
	"./webshop.png": 6671,
	"./webshop@2x.png": 4733,
	"./webshop@3x.png": 647,
	"./work-smarter/work-smarter.png": 850,
	"./work-smarter/work-smarter@2x.png": 417,
	"./work-smarter/work-smarter@3x.png": 5524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8542;